import styles from './styles.module.scss';

import cn from 'classnames';
import { useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

const TextArea = ({
  minRow = 1,
  maxRow = 4,
  value,
  width,
  fontSize,
  placeholder = '',
  onChange = () => {},
  onKeyPress = () => {},
  onBlur = () => {},
  onFocus = () => {},
  error = '',
  disabled,
  ...props
}) => {
  const [data, changeData] = useState(value || ''); // FIXME?
  const [focus, changeFocus] = useState(false);

  const onChangeData = (text) => {
    changeData(text);
    onChange(text);
  };

  useEffect(() => {
    changeData(value || '');
  }, [value]);

  return (
    <div className={styles.input_block}>
      <TextareaAutosize
        value={data}
        placeholder={placeholder}
        onChange={(e) => onChangeData(e.target.value)}
        className={cn(styles.textarea, styles.input_message, error.length > 0 && !focus && styles.error, props.styles)}
        onFocus={() => {
          changeFocus(true);
          onFocus();
        }}
        onBlur={() => {
          changeFocus(false);
          onBlur();
        }}
        style={{ width, fontSize, ...props.style }}
        minRows={minRow}
        maxRows={maxRow}
        disabled={disabled}
      />
      {error.length > 0 && (
        <span className={styles.error_message} style={{ maxWidth: width }}>
          {!focus && error}
        </span>
      )}
    </div>
  );
};

export default TextArea;
